module.exports = __webpack_public_path__ + "static/about-us-db220a09aaf4ec5faf51997abb22ef8e.jpg";